const mutations = {
    updateVisibleHeight: (state, value) => {
        state.screenWindow.visibleHeight = value;
    },

    updateVisibleScroll: (state, value) => {
        state.screenWindow.visibleScroll = value;
    },

    toggleSearchBoxFocus: (state, focused) => {
        state.inputHasFocus = focused;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/Screen/mutations.js